import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Typography,
  Box,
} from '@material-ui/core';
import { AspectRatio } from '@material-ui/icons';

const videoFullScreen = (index) => {
  const videos = document.getElementsByTagName('video');
  if (videos[index].requestFullscreen) {
    videos[index].requestFullscreen();
  } else if (videos[index].msRequestFullscreen) {
    videos[index].msRequestFullscreen();
  } else if (videos[index].mozRequestFullScreen) {
    videos[index].mozRequestFullScreen();
  } else if (videos[index].webkitRequestFullscreen) {
    videos[index].webkitRequestFullscreen();
  }
};

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
  },
  iconButton: {
    position: 'absolute',
    top: 228,
    right: 0,
    color: '#E7E7E7',
  },
  cardHeader: {
    padding: 12,
    '& span': {
      fontSize: 18,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
}));

function CardCctv({ id, idGroup, name, index, desc }) {
  const classes = useStyles();
  const targetRef = useRef();

  function hapusCCTV(dashboardString) {
    // Gunakan metode .replace() dengan ekspresi reguler untuk menghapus string "CCTV"
    var stringHasil = dashboardString.replace(/CCTV/g, '');
    return stringHasil;
  }

  return (
    <Card ref={targetRef} className={classes.root}>
      <CardHeader className={classes.cardHeader} title={hapusCCTV(name)} />
      <CardContent style={{ padding: 0, backgroundColor: '#000' }}>
        <ReactPlayer
          url={`https://camera.jtd.co.id/camera/bearer/jlp/${idGroup}/${id}/index.m3u8`}
          muted
          playing
          height='100%'
          width='100%'
        />
      </CardContent>
      {/* <IconButton
        className={classes.iconButton}
        aria-label='zoom'
        onClick={() => videoFullScreen(index)}
      >
        <AspectRatio />
      </IconButton> */}
      <Box
        style={{
          padding: 8,
          display: 'flex',
          justifyContent: 'space-between',
          alignContent: 'center',
        }}
      >
        <Typography
          variant='caption'
          style={{ fontSize: 14, display: 'flex', alignItems: 'center' }}
        >
          {desc}
        </Typography>
        <IconButton
          className={classes.iconButton}
          aria-label='zoom'
          color='white'
          onClick={() => videoFullScreen(index)}
        >
          <AspectRatio />
        </IconButton>
      </Box>
    </Card>
  );
}

CardCctv.propTypes = {
  id: PropTypes.number.isRequired,
  idGroup: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

export default CardCctv;
